import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
import { ItemApi } from 'appTypes/items'
import { ProductCardHorizontal } from 'components/ui/Card/ProductCardHorizontal'
import { useTranslation } from 'react-i18next'

type Props = {
  product: ItemApi
}

const BundleItems = ({ product }: Props): JSX.Element => {
  const { t } = useTranslation(['common'])

  return (
    <Box marginTop="24px">
      <Text fontSize="sm" marginBottom="12px">
        {t('itemsInBundle')}
      </Text>
      <Flex direction="column">
        {product?.products.map((pd) => (
          <ProductCardHorizontal key={pd.id} marginBottom="20px" product={pd} isDark />
        ))}
      </Flex>
    </Box>
  )
}

export default BundleItems
